import * as Sentry from '@sentry/browser';
import { SiteData } from './site-data';

export const siteDataFromSiteJson = (siteJson: SiteJson): SiteData => {
  try {
    if (!siteJson) {
      return {};
    }

    const widgetId =
      Object.keys(siteJson.pages.masterPage.widgetComponents).pop() || '';
    const widget = siteJson.pages.masterPage.widgetComponents[widgetId] || {
      style: {},
      data: {},
    };

    const appDate =
      siteJson.apps && siteJson.apps[0] ? siteJson.apps[0].appData : {};

    return {
      styleParams: {
        colors: widget.style.colors,
        fonts: { ...widget.style.fonts, ...widget.style.unstructuredFonts },
        booleans: widget.style.booleans,
      },
      siteColors: siteJson.siteColors,
      publicData: { ...appDate, ...widget.data },
    };
  } catch (e) {
    Sentry.captureException(e);
    return {};
  }
};
